import React, { useState, useEffect } from 'react';
import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import Page3 from './pages/Page3';
import Admin from './pages/Admin';
import CandidatePage from './pages/CandidatePage';
import LegalPage from './pages/LegalPage';
import ResultsPage from './pages/ResultsPage';
import ResultsTab from './pages/ResultsTab';
import './App.css';

function App() {
  // ── Admin is a fully separate entry point — reachable only by visiting /admin
  // directly, with no link, button, or icon anywhere on the public-facing site.
  const isAdminRoute = window.location.pathname === '/admin';
  // Legal pages reachable via direct URL too, for use in emails/social/etc.
  const isPrivacyRoute = window.location.pathname === '/privacy';
  const isTermsRoute = window.location.pathname === '/terms';
  // Election Results (/results, /results/IL, /results/IL/IL-governor) state ballots (/ballot, /ballot/IL) and the election guide (/guide)
  const isResultsRoute = /^\/(results|ballot|guide)(\/|$)/.test(window.location.pathname);

  if (isAdminRoute) {
    return <Admin />;
  }
  if (isPrivacyRoute) {
    return <LegalPage type="privacy" onBack={() => { window.location.href = '/'; }} />;
  }
  if (isTermsRoute) {
    return <LegalPage type="terms" onBack={() => { window.location.href = '/'; }} />;
  }
  if (isResultsRoute) {
    return <ResultsPage />;
  }

  return <PublicSite />;
}

function PublicSite() {
  const [currentPage, setCurrentPage] = useState(1);
  const [voterData, setVoterData] = useState(null);
  const [selectedRace, setSelectedRace] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [legalPage, setLegalPage] = useState(null); // 'privacy' | 'terms' | null

  const handlePage1Submit = (data) => {
    setVoterData(data);
    setCurrentPage(2);
    window.history.pushState({ page: 2 }, '');
  };

  const handleRaceSelect = (race) => {
    setSelectedRace(race);
    setCurrentPage(3);
    window.history.pushState({ page: 3 }, '');
  };

  const handleCandidateSelect = (candidate) => {
    setSelectedCandidate(candidate);
    setCurrentPage(4);
    window.history.pushState({ page: 4 }, '');
  };

  const handleShowLegal = (type) => {
    setLegalPage(type);
    window.history.pushState({ legal: type }, '');
  };

  const handleBack = () => {
    if (legalPage) {
      setLegalPage(null);
      return;
    }
    setCurrentPage((prevPage) => {
      if (prevPage === 4) {
        setSelectedCandidate(null);
        return 1;
      }
      return Math.max(1, prevPage - 1);
    });
  };

  useEffect(() => {
    const onPopState = () => { handleBack(); };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [legalPage]);

  if (legalPage) {
    return <LegalPage type={legalPage} onBack={() => setLegalPage(null)} />;
  }

  return (
    <div className="app">
      {currentPage === 1 && <Page1 onSubmit={handlePage1Submit} onCandidateSelect={handleCandidateSelect} onShowLegal={handleShowLegal} />}
      {currentPage === 2 && <Page2 voterData={voterData} onRaceSelect={handleRaceSelect} onBack={handleBack} />}
      {currentPage === 3 && selectedRace && <Page3 voterData={voterData} selectedRace={selectedRace} onBack={handleBack} />}
      {currentPage === 4 && selectedCandidate && <CandidatePage candidate={selectedCandidate} onBack={handleBack} />}
      <ResultsTab />
    </div>
  );
}

export default App;
